import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-month-selector',
  templateUrl: './app-month-selector.component.html',
  styleUrls: ['./app-month-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppMonthSelectorComponent {
  /** Array of month items to render (e.g. firstQuaterData) */
  @Input() months: any[] = [];

  /** Current active month identifier (e.g. currentMonth) */
  @Input() activeMonth: any = null;

  /** Active index if month matching by index */
  @Input() activeIndex: number = 0;

  /** Property name for month value */
  @Input() monthKey: string = 'month';

  /** Property name for year value */
  @Input() yearKey: string = 'year';

  /** Optional container CSS class */
  @Input() customClass: string = '';

  /** Emitted when a month pill is clicked (passes index for backwards compatibility) */
  @Output() monthSelect = new EventEmitter<number>();

  /** Emitted with full event details */
  @Output() monthChange = new EventEmitter<{ item: any; index: number }>();

  getMonthName(monthNum: number | string): string {
    if (monthNum === null || monthNum === undefined || monthNum === '') return '';
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const num = typeof monthNum === 'string' ? parseInt(monthNum, 10) : Number(monthNum);
    if (isNaN(num) || num < 1 || num > 12) return String(monthNum);
    return months[num - 1];
  }

  formatMonthLabel(item: any): string {
    if (!item) return '';
    if (typeof item === 'string') return item;
    const m = item[this.monthKey] ?? item.month;
    const y = item[this.yearKey] ?? item.year;
    const monthName = this.getMonthName(m);
    if (y) {
      return `${monthName}' ${y}`;
    }
    return monthName;
  }

  isItemActive(item: any, index: number): boolean {
    if (this.activeMonth !== null && this.activeMonth !== undefined) {
      const m = item[this.monthKey] ?? item.month;
      return m == this.activeMonth;
    }
    return index === this.activeIndex;
  }

  onSelectMonth(index: number, item: any): void {
    this.monthSelect.emit(index);
    this.monthChange.emit({ item, index });
  }
}
